"use client";

import { useRef } from "react";

import { Container } from "@/src/components/ui/Container";
import Section from "@/src/components/ui/Section";
import { Button } from "@/src/components/ui/Button";
import { Heading, Text, Highlight } from "@/src/components/ui/Typography";
import { StickyColumn } from "@/src/components/molecules/StickyColumn";
import { Accordion } from "@/src/components/molecules/Accordion";
import { paths } from "@/src/routes/paths";

import { whyChooseUsItems } from "./data";

export function WhyChooseUs() {
  const boundsRef = useRef<HTMLDivElement>(null);

  return (
    <Section className="bg-white">
      <Container>
        <div className="grid gap-12 md:grid-cols-2 md:gap-24">
          <StickyColumn boundsRef={boundsRef} className="h-fit self-start">
            <Heading as="h2" size="displayLG" className="max-w-125">
              Why SaaS Founders Choose{" "}
              <Highlight>TechEniac</Highlight> for AI Development
            </Heading>

            <Text size="bodyLG" className="mt-6 max-w-125 text-neutral-600">
              We design and deploy AI-SaaS systems with production in mind
              from day one. Strong foundations. Built to scale.
            </Text>

            <div className="mt-10">
              <Button href={paths.contactUs}>Start a Conversation</Button>
            </div>
          </StickyColumn>

          <div ref={boundsRef}>
            <Accordion items={whyChooseUsItems} defaultOpenIndex={0} />
          </div>
        </div>
      </Container>
    </Section>
  );
}
